import toast from "react-hot-toast";
import moment from "moment";

export const toastFunc = (type, message, duration) => {
  if (type === "success") {
    toast.success(message, {
      duration: 8000,
      position: "top-center",
      style: {
        fontSize: "1.6rem",     // Make text bigger
        padding: "25px 20px",   // Make the toast box bigger
        minWidth: "500px",      // Optional: set min width
        textAlign: "center",    // Center the text
      },
    });
  } else if (type === "error") {
    toast.error(message, {
      duration: 8000,
      position: "top-center",
      style: {
        fontSize: "1.6rem",     // Make text bigger
        padding: "25px 20px",   // Make the toast box bigger
        minWidth: "500px",      // Optional: set min width
        textAlign: "center",    // Center the text
      },
    });
  }
};

export const convertSecondsToHours = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const efficiency = (originalQuantityPerJobCard, quantityPerJobCard) => {
  const eff = quantityPerJobCard / originalQuantityPerJobCard;
  let perc = eff * 100;
  perc = perc > 1 ? 100 : perc;
  return `${perc.toFixed(2)}%`;
};

export const calculateTimeEfficiency = (actualSeconds, targetSeconds) => {
  if (!targetSeconds || targetSeconds === 0) return 0;

  let efficiency = (actualSeconds / targetSeconds) * 100;
  efficiency = Math.min(efficiency, 100); // cap at 100%
  return `${parseFloat(efficiency.toFixed(2))}%`;
}

export const formatNumber = (value, formatType) => {
  if (value === null || value === undefined || value === "" || isNaN(value)) {
    return "Invalid Input";
  }

  const number = parseFloat(value);

  switch (formatType) {
    case "decimal": // Converts to decimal format (e.g., 1234.56)
      return number.toFixed(2);
    case "currency": // Converts to currency format (e.g., ₹1,234.56)
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(number);
    case "percentage": // Converts to percentage format (e.g., 12.34%)
      return `${(number * 100).toFixed(2)}%`;
    case "scientific": // Converts to scientific notation (e.g., 1.23e+3)
      return number.toExponential(2);
    case "comma": // Adds commas for thousand separators (e.g., 1,234,567)
      return number.toLocaleString("en-IN");
    default:
      return number;
  }
};

export const disableButtonForSeconds = (button, duration = 8) => {
  if (!button) return;
  button.disabled = true;
  setTimeout(() => {
    button.disabled = false;
  }, duration * 1000);
};

export const getReportFilterMaxDays = (filterDaysLimit) => {
  const filterMaxDays = Number(filterDaysLimit?.filterMaxDays);

  if (
    filterDaysLimit?.enabled !== true ||
    !Number.isFinite(filterMaxDays) ||
    filterMaxDays < 0
  ) {
    return null;
  }

  return Math.floor(filterMaxDays);
};

export const validateReportDateRange = (
  fromDate,
  toDate,
  filterDaysLimit,
) => {
  const filterMaxDays = getReportFilterMaxDays(filterDaysLimit);

  if (!fromDate || !toDate) {
    return true;
  }

  const from = moment(fromDate).startOf("day");
  const to = moment(toDate).startOf("day");

  if (!from.isValid() || !to.isValid()) {
    return true;
  }

  if (to.isBefore(from)) {
    toastFunc("error", "To Date must be on or after From Date.", 8000);
    return false;
  }

  if (filterMaxDays !== null && to.diff(from, "days") > filterMaxDays) {
    toastFunc(
      "error",
      `Only ${filterMaxDays} days can be selected.`,
      8000,
    );
    return false;
  }

  return true;
};
